module.exports = __webpack_public_path__ + "static/img/detail.25c4692.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/anniversary/dialog/detail.png
// module id = ZeJG
// module chunks = 1